/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * DashBoard
 * OpenAPI spec version: v2.0.0
 */

export type TaskDataSourceType =
  (typeof TaskDataSourceType)[keyof typeof TaskDataSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskDataSourceType = {
  VARIABLE: 'VARIABLE',
  CSV_COLUMN: 'CSV_COLUMN',
} as const;
